// Staff tabs offer a reload once Flow is deployed (util/flow-update.js):
// checked when the tab comes back into view, and every 5 minutes.
import { CHECK_EVERY, createUpdateChecker, showUpdateToast } from '~/util/flow-update'

export default ({ store, $api }) => {
    if (!window.FLOW_BUILD) { return }
    const { check, dismiss } = createUpdateChecker({
        loaded: window.FLOW_BUILD,
        fetchBuild: () => $api.getBuild(),
        isStaff: () => !!store.getters.canAgent,
        onUpdate: () => window.$root && showUpdateToast(window.$root, { onDismiss: dismiss }),
    })
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') { check() }
    })
    window.addEventListener('focus', check)
    setInterval(check, CHECK_EVERY)
}
